// src/notifications/badges.js
import { Badge } from '@capawesome/capacitor-badge';

const KEY = 'shep_badge_counts';
// shape: { chat: number, waiting: number, updates: number }

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch { return {}; }
}
function write(obj) {
  localStorage.setItem(KEY, JSON.stringify(obj));
}

export async function setBadgeFromCounts() {
  const c = read();
  const total = (c.chat|0) + (c.waiting|0) + (c.updates|0);
  try { await Badge.set({ count: Math.max(0, total) }); } catch {}
}

export async function incBadge(type, by = 1) {
  const c = read();
  c[type] = Math.max(0, (c[type] || 0) + by);
  write(c);
  await setBadgeFromCounts();
}

export async function clearBadgeTypes(types = []) {
  const c = read();
  for (const t of types) c[t] = 0;
  write(c);
  await setBadgeFromCounts();
}

// sugar
export async function clearChatAndWaitingBadges() {
  await clearBadgeTypes(['chat', 'waiting']);
}
export async function clearUpdateBadge() {
  await clearBadgeTypes(['updates']);
}

// full reset if தேவையெனில்
export async function clearAllBadges() {
  await clearBadgeTypes(['chat','waiting','updates']);
}
